import { apiServer } from "common/config";
import { AddPhotoImageData } from "../types";
import { fetchWithToken } from "./fetchWithToken";
import {
  PhotoGuardrailError,
  getRejectedPhotos,
  resolveGuardrail,
  throwIfGuardrailRejected,
} from "./photoGuardrail";

export async function flagVenuePhotoMobile(
  photoId: string,
  token: string,
  notes: string,
  images: AddPhotoImageData[]
) {
  const fieldKeys: string[] = [];
  try {
    const formData = new FormData();
    formData.append("review_photo_id", photoId);
    formData.append("notes", notes);
    formData.append("image", images.length.toString());

    for (let i = 0; i < images.length; i++) {
      const imageUri = images[i].imageUrl;
      const fileName = `image${i}.jpg`;

      const file = {
        uri: imageUri,
        type: "image/jpeg",
        name: fileName,
      };
      formData.append(`image_${i}`, file as any, fileName);
      fieldKeys.push(`image_${i}`);
    }
    const response = await fetchWithToken(
      `${apiServer}/review/report-photo-issue`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      }
    );

    console.log(response);
    const data = await response?.json();

    throwIfGuardrailRejected(response, data, fieldKeys);

    if (data.status === "error") {
      console.log(data);
      return data.message;
    } else {
      return { ...data, rejectedPhotos: getRejectedPhotos(data, fieldKeys) };
    }
  } catch (error: any) {
    // Guardrail rejections must reach the caller as a typed error; the legacy
    // string return below is kept for every other failure.
    if (error instanceof PhotoGuardrailError) throw error;
    console.log(error);
    return error.message;
  }
}

export async function flagVenuePhotoDesktop(
  photoId: string,
  token: string,
  notes: string,
  images: AddPhotoImageData[]
) {
  const formData = new FormData();
  formData.append("review_photo_id", photoId);
  formData.append("notes", notes);

  // Record the exact FormData key per photo so the guardrail's rejected index
  // can be mapped back to the user's selection order.
  const fieldKeys: string[] = [];
  for (let i = 0; i < images.length; i++) {
    const blob = await (await fetch(images[i].imageUrl)).blob();
    formData.append(`image${i}`, blob, `image${i}.jpg`);
    fieldKeys.push(`image${i}`);
  }
  formData.append("image", images.length.toString());

  const response = await fetchWithToken(
    `${apiServer}/review/report-photo-issue`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    }
  );

  return resolveGuardrail(response, fieldKeys);
}

export async function flagVenueReviewMobile(
  reviewId: string,
  token: string,
  notes: string,
  images: AddPhotoImageData[]
) {
  const fieldKeys: string[] = [];
  try {
    const formData = new FormData();
    formData.append("review_id", reviewId);
    formData.append("notes", notes);
    formData.append("image", images.length.toString());

    for (let i = 0; i < images.length; i++) {
      const imageUri = images[i].imageUrl; // Assuming you want to send the first image
      const fileName = `image${i}.jpg`; // Adjust accordingly

      const file = {
        uri: imageUri,
        type: "image/jpeg",
        name: fileName,
      };
      formData.append(`image${i}`, file as any, fileName);
      fieldKeys.push(`image${i}`);
    }
    // for (let i = 0; i < images.length; i++) {
    //   const imageUri = images[i].imageUrl;
    //   const fileName = `image${i}.jpg`;

    //   // Convert the base64 image to a Blob
    //   const response = await fetch(imageUri);
    //   const blob = await response.blob();

    //   formData.append(`image${i}`, blob, fileName);
    // }

    const response = await fetchWithToken(`${apiServer}/review/report-issue`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    const data = await response?.json();

    throwIfGuardrailRejected(response, data, fieldKeys);

    if (data.status === "error") {
      console.log(data);
      return data.message;
    } else {
      return { ...data, rejectedPhotos: getRejectedPhotos(data, fieldKeys) };
    }
  } catch (error: any) {
    // Guardrail rejections must reach the caller as a typed error; the legacy
    // string return below is kept for every other failure.
    if (error instanceof PhotoGuardrailError) throw error;
    console.log(error);
    return error.message;
  }
}

export async function flagVenueReviewDesktop(
  reviewId: string,
  token: string,
  notes: string,
  images: AddPhotoImageData[]
) {
  const formData = new FormData();
  formData.append("review_id", reviewId);
  formData.append("notes", notes);

  const fieldKeys: string[] = [];
  for (let i = 0; i < images.length; i++) {
    const blob = await (await fetch(images[i].imageUrl)).blob();
    formData.append(`image${i}`, blob, `image${i}.jpg`);
    fieldKeys.push(`image${i}`);
  }
  formData.append("image", images.length.toString());

  const response = await fetchWithToken(`${apiServer}/review/report-issue`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  return resolveGuardrail(response, fieldKeys);
}

export async function flagVenueAccessibiilityMobile(
  businessId: string,
  categoryId: string,
  typeQuestionId: string,
  typeQuestionTagId: string,
  token: string,
  notes: string,
  images: AddPhotoImageData[]
) {
  const fieldKeys: string[] = [];
  try {
    const formData = new FormData();
    formData.append("business_id", businessId);
    formData.append("category_id", categoryId);
    formData.append("type_question_id", typeQuestionId);
    formData.append("type_question_tag_id", typeQuestionTagId);
    formData.append("notes", notes);
    formData.append("image", images.length.toString());

    for (let i = 0; i < images.length; i++) {
      const imageUri = images[i].imageUrl;
      const fileName = `image${i}.jpg`;

      const file = {
        uri: imageUri,
        type: "image/jpeg",
        name: fileName,
      };
      formData.append(`image${i}`, file as any, fileName);
      fieldKeys.push(`image${i}`);
    }

    const response = await fetchWithToken(
      `${apiServer}/review/accessibility-report-issue`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      }
    );

    const data = await response?.json();

    throwIfGuardrailRejected(response, data, fieldKeys);

    if (data.status === "error") {
      console.log(data);
      return data.message;
    } else {
      return { ...data, rejectedPhotos: getRejectedPhotos(data, fieldKeys) };
    }
  } catch (error: any) {
    // Guardrail rejections must reach the caller as a typed error; the legacy
    // string return below is kept for every other failure.
    if (error instanceof PhotoGuardrailError) throw error;
    console.log(error);
    return error.message;
  }
}

export async function flagVenueAccessibiilityDesktop(
  businessId: string,
  categoryId: string,
  typeQuestionId: string,
  typeQuestionTagId: string,
  token: string,
  notes: string,
  images: AddPhotoImageData[]
) {
  const formData = new FormData();
  formData.append("business_id", businessId);
  formData.append("category_id", categoryId);
  formData.append("type_question_id", typeQuestionId);
  formData.append("type_question_tag_id", typeQuestionTagId);
  formData.append("notes", notes);

  const fieldKeys: string[] = [];
  for (let i = 0; i < images.length; i++) {
    const blob = await (await fetch(images[i].imageUrl)).blob();
    formData.append(`image${i}`, blob, `image${i}.jpg`);
    fieldKeys.push(`image${i}`);
  }
  formData.append("image", images.length.toString());

  const response = await fetchWithToken(
    `${apiServer}/review/accessibility-report-issue`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    }
  );

  return resolveGuardrail(response, fieldKeys);
}

// Shared web/native fn. resolveGuardrail preserves the prior throw-on-error
// contract (it throws on rejection/outage) and only adds `rejectedPhotos` on
// success, so native's existing catch is unaffected.
export async function reportSpaceIssue(
  reviewLevelId: string,
  businessId: string,
  notes: string,
  token: string,
  images: AddPhotoImageData[]
) {
  const formData = new FormData();
  formData.append("review_level_id", reviewLevelId);
  formData.append("business_id", businessId);
  formData.append("notes", notes);

  const fieldKeys: string[] = [];
  for (let i = 0; i < images.length; i++) {
    const blob = await (await fetch(images[i].imageUrl)).blob();
    formData.append(`image${i}`, blob, `image${i}.jpg`);
    fieldKeys.push(`image${i}`);
  }
  formData.append("image", images.length.toString());

  const response = await fetchWithToken(
    `${apiServer}/review/report-space-issue`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    }
  );

  return resolveGuardrail(response, fieldKeys);
}
